export default __webpack_public_path__ + "static/media/store_apple.92b9804a.svg";